module.exports = __webpack_public_path__ + "img/solution-cokpit6-system-pic.01e6b9ad.png";